import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useUpdateSendEmailName = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (id: string, name: string) => {
      dispatch({
        type: 'UPDATE_SEND_EMAIL_NAME',
        payload: {
          id,
          name,
        },
      });
    },
    [dispatch],
  );
};
